var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AsciiText } from './framework/AsciiText';
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
const playerMediaOperationCaps = [
    'back',
    'directionEnter',
    'directionUpDownLeftRight',
    'back',
    'home',
    'menu',
];
export class PensarLed {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.configuredCodes = [];
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'connectFailed',
                send: this.makeCommand([6, 0, 0, 0, 0, 0, 4, 0, 0, 0, 1, 0]),
                next: /\xAA\x55\x00\x01\x00\xFC\x06[\x00]{5}\x04[\x00]{3}\x01\x00[\s\S][\S\s]/,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.mediaOperation = {
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                if (value.operation === 'directionLeft') {
                    yield this.socket.send(this.makeCommand([7, 0, 0, 0, 1, 0, 0x0a, 0, 0, 0, 1, 0, 0]), /\xAA\x55([\S\s])\x01\x00\xFC\x07[\x00]{3}\x01\x00\x0A[\x00]{5}[\S\s]/, tags);
                }
                else if (value.operation === 'directionRight') {
                    yield this.socket.send(this.makeCommand([7, 0, 0, 0, 1, 0, 0x0b, 0, 0, 0, 1, 0, 0]), /\xAA\x55([\S\s])\x01\x00\xFC\x07[\x00]{3}\x01\x00\x0b[\x00]{5}[\S\s]/, tags);
                }
                else if (value.operation === 'directionUp') {
                    yield this.socket.send(this.makeCommand([7, 0, 0, 0, 1, 0, 8, 0, 0, 0, 1, 0, 0]), /\xAA\x55([\S\s])\x01\x00\xFC\x07[\x00]{3}\x01\x00\x08[\x00]{5}[\S\s]/, tags);
                }
                else if (value.operation === 'directionDown') {
                    yield this.socket.send(this.makeCommand([7, 0, 0, 0, 1, 0, 9, 0, 0, 0, 1, 0, 0]), /\xAA\x55([\S\s])\x01\x00\xFC\x07[\x00]{3}\x01\x00\x09[\x00]{5}[\S\s]/, tags);
                }
                else if (value.operation === 'directionEnter') {
                    // OK command
                    yield this.socket.send(this.makeCommand([7, 0, 0, 0, 1, 0, 0x0c, 0, 0, 0, 1, 0, 0]), /\xAA\x55([\S\s])\x01\x00\xFC\x07[\x00]{3}\x01\x00\x0c[\x00]{5}[\S\s]/, tags);
                }
                else if (value.operation === 'back') {
                    // Back command
                    yield this.socket.send(this.makeCommand([7, 0, 0, 0, 1, 0, 2, 0, 0, 0, 1, 0, 0]), /\xAA\x55([\S\s])\x01\x00\xFC\x07[\x00]{3}\x01\x00\x02[\x00]{5}[\S\s]/, tags);
                }
                else if (value.operation === 'home') {
                    yield this.socket.send(this.makeCommand([7, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0]), /\xAA\x55([\S\s])\x01\x00\xFC\x07[\x00]{3}\x01\x00\x01[\x00]{5}[\S\s]/, tags);
                }
                else if (value.operation === 'menu') {
                    // Settings command
                    yield this.socket.send(this.makeCommand([7, 0, 0, 0, 1, 0, 3, 0, 0, 0, 1, 0, 0]), /\xAA\x55([\S\s])\x01\x00\xFC\x07[\x00]{3}\x01\x00\x03[\x00]{5}[\S\s]/, tags);
                }
                return value;
            }),
        };
        this.mediaOperations = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const ops = {};
                for (const code of this.configuredCodes) {
                    ops[code] = [...playerMediaOperationCaps];
                }
                return ops;
            }),
        };
        this.power = {
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand([8, 0, 0, 0, 1, 0, power ? 2 : 1, 0, 0, 0, 1, 0, 0]), /\xAA\x55([\S\s])\x01\x00\xFC\x08[\S\s]{12}/, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 1000);
                return match[1].charCodeAt(0) === 0 ? power : this.state.power.value;
            }),
            isStateless: true,
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand([6, 0, 0, 0, 0, 0, 4, 0, 0, 0, 1, 0]), /\xAA\x55\x00\x01\x00\xFC\x06[\x00]{5}\x04[\x00]{3}\x01\x00([\s\S])/, tags);
                const code = match[1].charCodeAt(0).toString();
                return code === '4' ? '3' : code; // the display returns 4 when input 3 is selected
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand([8, 0, 0, 0, 1, 0, 4, 0, 0, 0, 1, 0, parseInt(code, 10)]), /\xAA\x55([\S\s])\x01\x00\xFC\x08/, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 4000);
                return match[1].charCodeAt(0) === 0 ? code : this.state.videoInput.value;
            }),
        };
        // polling
        this.polls = [{ intervalMs: 3000, controls: ['videoInput'] }];
    }
    // phase callbacks
    onConfigure(config) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            this.configuredCodes = Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {}).map(v => v.code);
            if (this.configuredCodes.length > 0 &&
                (this.currentInputCode === undefined ||
                    !this.configuredCodes.includes(this.currentInputCode))) {
                this.currentInputCode = this.configuredCodes.sort()[0];
            }
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
    // other class methods
    makeCommand(command) {
        let data = [0x55, 0xaa, 0x00, 0x01, 0xfc, 0x00]; // command header
        data = data.concat(command);
        let checksum = 0;
        for (const datum of data) {
            checksum += datum;
        }
        data.push((checksum - data[1]) & 0x00ff); // don't include 0xAA at index 1
        return AsciiText.decode(data);
    }
}
// static properties
PensarLed.driverType = 'socketDriver';
PensarLed.key = '-Mbwe5o0JJheYE8nCN4m';
PensarLed.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\x56'],
    },
    sendTerminator: '\x56',
    isBinary: true,
};
PensarLed.socketOptions = [
    Object.assign(Object.assign({}, PensarLed.baseSocketOptions), { port: 5200 }),
];
